module.exports = __webpack_public_path__ + "static/media/24UHCHR5.51fa709d.jpg";